module.exports = __webpack_public_path__ + "static/media/L3.9847b2cf.jpg";